import { createContext } from 'react';

import type { ReviewsContext } from '../types/hotel-reviews';

export const HotelReviewsContext = createContext<Partial<ReviewsContext>>({});
